import { useUpdateCheck } from '../../hooks/useUpdateCheck';
import React from 'react';


const UpdateCheck = (props) => {
    const { interval } = props;

    const { status, reloadPage } = useUpdateCheck({ interval: interval });

    if (status === "available") {
        reloadPage();
    }

    return null;
};

export default UpdateCheck;